module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"reviews_count":"レビュー {count}"}}')
  delete Component.options._Ctor
}
